
import { useMemo } from 'react'

import { format, parseJSON } from 'date-fns'

import { IGridColumn } from 'components/common'
import { DATE_TIME_FORMAT } from 'constants/index'

export const useGetDriverInvoicesColumns = () => {
  const columns: IGridColumn[] = useMemo(
    () => [
      { field: 'id', headerName: 'Id', width: 100 },
      {
        field: 'booking',
        headerName: 'Invoice Number',
        minWidth: 150,
        flex: 1,
        sortPath: ['booking', 'ourReference'],
        valueGetter: ({ value, row }) => row?.invoiceNumber ?? value?.ourReference,
      },
      {
        field: 'invoiceDate',
        headerName: 'Invoice Date',
        minWidth: 150,
        flex: 1,
        valueFormatter: ({ value }) =>
          value && format(parseJSON(value as string), DATE_TIME_FORMAT),
      },
      {
        field: 'pOAddressLine1',
        headerName: 'PO Address Line 1',
        minWidth: 150,
        flex: 1,
        valueGetter: ({ row }) => row?.poAddressLine1,
      },
      {
        field: 'dueDate',
        headerName: 'Due Date',
        minWidth: 150,
        flex: 1,
        valueFormatter: ({ value }) =>
          value && format(parseJSON(value as string), DATE_TIME_FORMAT),
      },
    ],
    [],
  )
  return columns
}
